export default "assets/cart-4bbdd4bc.svg";